var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"bf-copy-rows-btn",attrs:{"variant":"primary","disabled":_vm.copyBtnDisabled},on:{"click":_vm.onCopyDataClicked}},[_vm._v(_vm._s(_vm.getText('copy_btn')))])}
var staticRenderFns = []

export { render, staticRenderFns }